export const PRIVATE_ROUTES_PATH = {
    DASHBOARD: '',
    MERCHANT: 'merchant',
    WALLET: 'wallet',
    WALLET_DETAIL: 'wallet-detail',
    CHECKOUT: 'checkouts',
    DONATION_PAGE: 'donation-page'
};
